import React from "react";
import { Accordion, Card, Stack, Text } from "@bookingcom/bui-react";
import { CardAirlineGroup } from "@flights/search-ui";
export function FlightDetailsSegmentAccordionMobileUI(props) {
    const { children, attributes, mixin, title, subtitle, airlineCodes, titleAttributes, subtitleAttributes, defaultActive, onOpen, onClose } = props;
    return (React.createElement(Card, { mixin: mixin, attributes: attributes },
        React.createElement(Accordion, { onOpen: onOpen, onClose: onClose, defaultActive: defaultActive, titleContent: React.createElement(Stack, { gap: 4, direction: "row" },
                React.createElement(CardAirlineGroup, { codes: airlineCodes, size: 48 }),
                React.createElement(Stack.Item, { grow: true },
                    React.createElement(Stack, { gap: 0 },
                        React.createElement(Text, { tagName: "h3", attributes: titleAttributes, variant: "strong_2" }, title),
                        React.createElement(Text, { attributes: subtitleAttributes, variant: "small_1", color: "neutral_alt" }, subtitle)))) }, children)));
}
